import { Injectable } from '@angular/core';
import { AmplitudeService } from '@brighthub/logging';

@Injectable()
export class BrightNavAmplitudeService extends AmplitudeService {
  override logEvent(eventName: string, props?: Record<string, any>): void {
    super.logEvent(eventName, {
      ...props,
      app: 'brightnav',
    });
  }
}
